module.exports = __webpack_public_path__ + "static/img/introduction-welcome-energy-paradox.9b46446.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/introduction-welcome-energy-paradox.jpg
// module id = dhO3
// module chunks = 0